// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"g5-z","yourQuestionLabel":"h5-z","notAuthedMessage":"i5-z","form":"j5-z","textarea":"k5-z","error":"l5-z","disabled":"m5-z","edited":"n5-z","submit":"o5-z"};